module.exports = __webpack_public_path__ + "img/slogan.6b9cfc4.svg";